"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartSettingsField = void 0;
const react_1 = __importStar(require("react"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const react_table_1 = require("react-table");
const styled_1 = require("./styled");
const hooks_1 = require("./hooks");
const chartOptions = [
    { value: 'column', label: 'Column Chart' },
    { value: 'area', label: 'Area Chart' },
    { value: 'line', label: 'Line Chart' }
];
const ChartSettingsField = (field) => {
    const { onChange, formData } = field;
    const options = (0, react_1.useMemo)(() => { var _a, _b; return (_b = (_a = field.formContext) === null || _a === void 0 ? void 0 : _a.dataFields) !== null && _b !== void 0 ? _b : []; }, [field]);
    const [localData, setLocalData] = (0, react_1.useState)([]);
    const mergedOptions = (0, hooks_1.useOptionsFromFormData)(options, localData);
    (0, react_1.useEffect)(() => {
        if (Array.isArray(formData)) {
            setLocalData(formData);
        }
        else {
            setLocalData([]);
        }
    }, []);
    (0, hooks_1.useSyncChartSettings)(formData, mergedOptions, setLocalData, onChange);
    const handleChange = (0, react_1.useCallback)((id, selected) => {
        setLocalData((prevData) => {
            const updated = prevData.map((item) => item.id === id ? Object.assign(Object.assign({}, item), { chartType: selected }) : item);
            onChange(updated);
            return updated;
        });
    }, [onChange, mergedOptions]);
    const columns = (0, react_1.useMemo)(() => [
        {
            Header: 'Chart Field',
            accessor: 'title'
        },
        {
            Header: 'Chart Type',
            accessor: 'chartType',
            Cell: ({ row }) => {
                const currentValue = row.original.chartType;
                return (react_1.default.createElement(wl_ui_kit_1.Select, { value: chartOptions.find((o) => o.value === currentValue), onChange: (selected) => handleChange(row.original.id, selected.value), options: chartOptions }));
            }
        }
    ], []);
    const tableInstance = (0, react_table_1.useTable)({
        columns,
        data: mergedOptions,
        initialState: { pageSize: 5 }
    }, react_table_1.usePagination);
    return (react_1.default.createElement(styled_1.TableWrap, null,
        react_1.default.createElement(wl_ui_kit_1.Table, { key: mergedOptions.map((i) => i.chartType).join(','), tableInstance: tableInstance })));
};
exports.ChartSettingsField = ChartSettingsField;
//# sourceMappingURL=chart-settings-field.js.map